import { render, staticRenderFns } from "./fullscreen-wrapper.component.vue?vue&type=template&id=9a51c100&"
import script from "./fullscreen-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./fullscreen-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports